// initial state
import {gaState, toFaNum} from "../../helpers";

const state = () => ({
    items: [],
    cartLoading: false,
})

// getters
const getters = {

    cartTotalPrice: (state) => {
        return state.items.reduce((total, item) => {
            return total + item.state.price * item.count
        }, 0)
    },

    cartBasedOnProduct: (state) => {
        let cartProducts = []
        state.items.forEach((item) => {
            let productIndex = cartProducts.findIndex(product => product.id === item.state.product.id)
            if (productIndex === -1) {
                let {product} = JSON.parse(JSON.stringify(item.state))
                product.states = [
                    item
                ]
                cartProducts.push(product)
            } else {
                cartProducts[productIndex].states.push(item)
            }
        })
        return cartProducts
    },

    stateMsg: (state, getters) => (product) => {
        const maxInCart = product.maxInCart
        const stateStockCount = product.license_bank.license_count
        const stateInCartCount = getters.stateCountInCart(product)

        if (stateStockCount && stateStockCount >= stateInCartCount) {
            return "<strong>سفارش شما به صورت آنی ارسال می شود</strong>"
        } else {
            if (stateStockCount === 0) {
                return `<strong>${product.overStockInventoryMsg}</strong>` || "<strong>محصول حداکثر ۲۴ ساعت پس از خرید برای شما ارسال خواهد شد</strong>"
            }
            return "<strong>" +
                "فقط تعداد " +
                toFaNum(stateStockCount) +
                " عدد از این محصول موجود است که به صورت آنی پس از خرید برای شما ارسال می‌شود. الباقی پس از حداکثر ۲۴ ساعت برای شما ارسال خواهد شد" +
                "</strong>"
        }
    },

    stateCountInCart: (state) => (selectedState) => {
        const item = state.items.find(item => item.state.id === selectedState.id)
        return item ? item.count : 0
    },

    stateCount: (state) => {
        return toFaNum(state.items.length)
    }

}

// actions
const actions = {
    cartTouchErrors({commit}, data) {
        if (data.touch.errors) {
            data.touch.errors.forEach(msg => {
                commit('toasts/addToast', {
                    type: 'error',
                    content: msg,
                }, {
                    root: true
                })
            })
        }
    },
    async getCartItems({state, commit, dispatch}) {
        if (state.cartLoading) {
            return
        }
        commit('setCartLoading', true)
        const res = await axios.get('/api/v1/index/cart')
        const {data} = res

        dispatch('cartTouchErrors', data)

        commit('setCartLoading', false)
        commit('setCartItems', data.cart)
    },
    async addProductToCart({state, commit, dispatch}, {product, count = 1, showCanvas = true}) {
        if (state.cartLoading) {
            return
        }
        commit('setCartLoading', true)

        const res = await axios.post('/api/v1/index/cart', {
            state_id: product.id,
            count
        })
        const {data} = res

        dispatch('cartTouchErrors', data)

        commit('setCartItems', data.cart)
        commit('setCartLoading', false)

        if (data.errors && data.errors.count) {
            data.errors.count.forEach(msg => {
                commit('toasts/addToast', {
                    type: 'error',
                    content: msg,
                }, {
                    root: true
                })
            })
        } else {
            if (count > 0) {
                if (showCanvas) {
                    bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('cart-box')).show()
                }
                gtag("event", "add_to_cart", {
                    currency: "USD",
                    value: 0,
                    items: [
                        {
                            ...gaState(product),
                            quantity: count
                        }
                    ]
                })
            } else {
                gtag("event", "remove_from_cart", {
                    currency: "USD",
                    value: 0,
                    items: [
                        {
                            ...gaState(product),
                            quantity: -count
                        }
                    ]
                })
            }
        }
    },
}

// mutations
const mutations = {
    pushProductToCart(state, product) {
        state.items.push({
            product,
            quantity: 1
        })
    },

    incrementItemQuantity(state, product) {
        const cartItem = state.items.find(item => item.product.id === product.id)
        cartItem.quantity++
    },

    setCartItems(state, items) {
        state.items = items
    },

    setCartLoading(state, cartLoading) {
        state.cartLoading = cartLoading
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
